import { gql } from "graphql-request";

const SERVER_GET_BRANCH_OFFICE_NAMES = gql`
{
  branchOfficeNames
}
`

export default SERVER_GET_BRANCH_OFFICE_NAMES;